var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.33333V18.6667C24.4996 19.0758 24.3916 19.4777 24.1868 19.832C23.982 20.1862 23.6877 20.4804 23.3333 20.685L15.1667 25.3517C14.812 25.5565 14.4096 25.6643 14 25.6643C13.5904 25.6643 13.188 25.5565 12.8333 25.3517L4.66667 20.685C4.31231 20.4804 4.01798 20.1862 3.81321 19.832C3.60843 19.4777 3.50042 19.0758 3.5 18.6667V9.33333C3.50042 8.92415 3.60843 8.52228 3.81321 8.16802C4.01798 7.81377 4.31231 7.51959 4.66667 7.315L12.8333 2.64833C13.188 2.44354 13.5904 2.33572 14 2.33572C14.4096 2.33572 14.812 2.44354 15.1667 2.64833L23.3333 7.315C23.6877 7.51959 23.982 7.81377 24.1868 8.16802C24.3916 8.52228 24.4996 8.92415 24.5 9.33333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81543 8.12L14.0004 14.0117L24.1854 8.12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.76V14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.dfdedf01a3d0393c3069d05b48b927c5.svg";
export { ForwardRef as ReactComponent };